import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import { md3 } from 'vuetify/blueprints'
import { THEME_DEFINITIONS, THEME_TO_VUETIFY } from '../constants/themes'
import {
  VAlert,
  VApp,
  VAppBar,
  VAutocomplete,
  VAvatar,
  VBadge,
  VBtn,
  VBtnGroup,
  VBtnToggle,
  VCard,
  VCardActions,
  VCardSubtitle,
  VCardTitle,
  VCardText,
  VCheckbox,
  VCheckboxBtn,
  VChip,
  VChipGroup,
  VColorPicker,
  VCol,
  VCombobox,
  VContainer,
  VDataTable,
  VDatePicker,
  VDialog,
  VDivider,
  VExpansionPanel,
  VExpansionPanels,
  VExpansionPanelText,
  VExpansionPanelTitle,
  VFadeTransition,
  VFileInput,
  VForm,
  VIcon,
  VImg,
  VInput,
  VList,
  VListGroup,
  VListItem,
  VListItemSubtitle,
  VListItemTitle,
  VListSubheader,
  VMain,
  VMenu,
  VNavigationDrawer,
  VNumberInput,
  VOverlay,
  VProgressCircular,
  VProgressLinear,
  VRadio,
  VRadioGroup,
  VRow,
  VSheet,
  VSelect,
  VSkeletonLoader,
  VSlideGroup,
  VSlideGroupItem,
  VSlider,
  VSnackbar,
  VSpacer,
  VStepper,
  VStepperHeader,
  VStepperItem,
  VStepperWindow,
  VStepperWindowItem,
  VSwitch,
  VTab,
  VTable,
  VTabs,
  VTextarea,
  VTextField,
  VTimeline,
  VTimelineItem,
  VToolbar,
  VToolbarTitle,
  VTooltip,
  VWindow,
  VWindowItem,
} from 'vuetify/components'
import { VDateInput } from 'vuetify/labs/VDateInput'
import * as directives from 'vuetify/directives'

const vuetifyThemes = Object.fromEntries(
  (Object.keys(THEME_DEFINITIONS) as (keyof typeof THEME_DEFINITIONS)[]).map((id) => [
    THEME_TO_VUETIFY[id],
    { dark: THEME_DEFINITIONS[id].dark, colors: THEME_DEFINITIONS[id].colors },
  ]),
)

export const vuetify = createVuetify({
  components: {
    VAlert,
    VApp,
    VAppBar,
    VAutocomplete,
    VAvatar,
    VBadge,
    VBtn,
    VBtnGroup,
    VBtnToggle,
    VCard,
    VCardActions,
    VCardSubtitle,
    VCardTitle,
    VCardText,
    VCheckbox,
    VCheckboxBtn,
    VChip,
    VChipGroup,
    VColorPicker,
    VCol,
    VCombobox,
    VContainer,
    VDateInput,
    VDataTable,
    VDatePicker,
    VDialog,
    VDivider,
    VExpansionPanel,
    VExpansionPanels,
    VExpansionPanelText,
    VExpansionPanelTitle,
    VFadeTransition,
    VFileInput,
    VForm,
    VIcon,
    VImg,
    VInput,
    VList,
    VListGroup,
    VListItem,
    VListItemSubtitle,
    VListItemTitle,
    VListSubheader,
    VMain,
    VMenu,
    VNavigationDrawer,
    VNumberInput,
    VOverlay,
    VProgressCircular,
    VProgressLinear,
    VRadio,
    VRadioGroup,
    VRow,
    VSheet,
    VSelect,
    VSkeletonLoader,
    VSlideGroup,
    VSlideGroupItem,
    VSlider,
    VSnackbar,
    VSpacer,
    VStepper,
    VStepperHeader,
    VStepperItem,
    VStepperWindow,
    VStepperWindowItem,
    VSwitch,
    VTab,
    VTable,
    VTabs,
    VTextarea,
    VTextField,
    VTimeline,
    VTimelineItem,
    VToolbar,
    VToolbarTitle,
    VTooltip,
    VWindow,
    VWindowItem,
  },
  directives,
  blueprint: md3,
  theme: {
    defaultTheme: THEME_TO_VUETIFY.light,
    themes: vuetifyThemes,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi },
  },
  defaults: {
    global: {
      style: {
        fontFamily: 'Inter, sans-serif',
      },
    },
  },
})
